import React, { MouseEventHandler } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../../utils';

const CloseButton = ({
  onClick,
  className,
}: {
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-7 h-7 hover:bg-secondary rounded-full hover:text-white backdrop-blur-lg text-grayText p-1 centerDiv animated',
        className
      )}
    >
      <X />
    </button>
  );
};

export default CloseButton;
